import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

export const listDeviceStates = async () =>
  await blazeDevicePromiseClient.listDeviceStates({});
